import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { Link, withRouter } from 'react-router-dom';
import { useLang, withLang } from '../../util/lang';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Animated } from 'react-animated-css';
import PercentageProgressRing from '../../components/PercentageProgressRing';
import useRetainerRequestForm from '../hooks/DiffRetainerHooks/useRetainerRequestForm';
import { getUpperAndLowerImpressionTypeSchema } from '../../components/DifferentRetainer/YupValidation';
import useTeethSelections from '../hooks/DiffRetainerHooks/useTeethSelections';
import { DiffRetainerLangContext } from '../../components/DifferentRetainer/PrescriptionNote/hooks/useDiffRetainerLangContext';
import DiffRetainerForm from './DiffRetainerForm';
import Banner from '../../components/Banner';
import axios from '../../axios-default';
import { baseImpressionOption } from './utils';
import useAuth from '../../hooks/useAuth';

export const getFieldName = (field) => {
    switch (field) {
        case 'clearRetainerDesignUpperOption':
            return 'clearRetainerDesignUpper';
        case 'clearRetainerDesignLowerOption':
            return 'clearRetainerDesignLower';
        default:
            return field;
    }
};
const styles = (theme) => ({});

function DiffRetainers(props) {
    const { match, history, isReSubmit, resubmitProps } = props;
    const caseId = match.params.id || null;
    const getDiffRetainerLang = useLang('DiffRetainer');
    const getGlobalLang = useLang('global');

    const progressBarRef = useRef(null);

    const [loading, setLoading] = useState(false);
    const [impressionType, setImpressionType] = useState(undefined);
    const singleRetainerTypeFormProps = useRetainerRequestForm({ schema: null, isTab: false });
    const upperAndLowerRetainerSchema = getUpperAndLowerImpressionTypeSchema(
        getGlobalLang('@global.const.required'),
        false
    );
    const upperAndLowerRetainerTypeFormProps = useRetainerRequestForm({
        schema: upperAndLowerRetainerSchema,
        isTab: false,
    });
    const {
        baseTeethSelections,
        upperAndLowerTeethSelections,
        handleFormValuesWithTeethSelections,
        resetAllTeethSelections,
    } = useTeethSelections();
    const [specialInstruction, setSpecialInstruction] = useState('');
    const auth = useAuth();

    const [impressionOption, setImpressionOption] = useState(baseImpressionOption);

    useEffect(() => {
        let role = auth.user?.role || null;
        const getImpressionOption = async () => {
            const res = await axios.get(`retainerType/impressionOption/${caseId}`);
            if (res.status === 200 && res.data && res.data?.option) {
                setImpressionOption(res.data.option);
            }
        };

        if (caseId && role && role === 'DR') {
            getImpressionOption();
        }

        return () => {
            setImpressionOption(baseImpressionOption);
        };
    }, [caseId, auth.user.role]);

    const baseProps = {
        singleRetainerTypeFormProps,
        upperAndLowerRetainerTypeFormProps,
        baseTeethSelections,
        upperAndLowerTeethSelections,
        handleFormValuesWithTeethSelections,
        resetAllTeethSelections,

        impressionType,
        setImpressionType,
        specialInstruction,
        setSpecialInstruction,
    };

    const hideUpperGrid = useMemo(() => {
        if (!isReSubmit) return false;
        return true;
    }, [isReSubmit]);

    return (
        <>
            <Fragment>
                <Animated animationIn="fadeIn" isVisible={true} style={{ backgroundColor: 'rgb(242, 242, 242)' }}>
                    <PercentageProgressRing ref={progressBarRef} open={loading} />

                    <Grid container style={{ padding: 16, background: '#fff' }}>
                        {!hideUpperGrid && (
                            <>
                                <Grid item xs={12} style={{ padding: 32 }}>
                                    <Banner />
                                </Grid>

                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            margin: '8px 0px',
                                        }}
                                    >
                                        <Link
                                            to="/"
                                            style={{
                                                color: 'black',
                                            }}
                                        >
                                            {getGlobalLang('@PatientInfo.breadcrumbs.caseManagement')}
                                        </Link>
                                        {` > `}
                                        <Link
                                            to={`/patients/${props.match.params.id}`}
                                            style={{
                                                color: 'black',
                                            }}
                                        >
                                            {`${getGlobalLang('@PatientInfo.breadcrumbs.patient')} #${props.match.params.id}`}
                                        </Link>
                                        {` > ${getGlobalLang('@PatientInfo.breadcrumbs.retainers')}`}
                                    </div>
                                </Grid>
                            </>
                        )}

                        <DiffRetainerLangContext.Provider value={{ getDiffRetainerLang, impressionOption }}>
                            <Grid item xs={12}>
                                <DiffRetainerForm
                                    caseId={caseId}
                                    setLoading={setLoading}
                                    history={history}
                                    onProgressChange={progressBarRef?.current?.onProgressChange}
                                    baseProps={baseProps}
                                    isTab={false}
                                    isReSubmit={isReSubmit}
                                    resubmitProps={resubmitProps}
                                />
                            </Grid>
                        </DiffRetainerLangContext.Provider>
                    </Grid>
                </Animated>
            </Fragment>
        </>
    );
}

const mapStateToProps = (store) => {
    return {
        NewPatientData: store.newPatientReducer,
        files: store.newPatientReducer.files,
        config: store.config.config,
        lang: store.lang,
        isLoading: store.loading.isLoading,
        diffRetainer: store.diffRetainer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(DiffRetainers, 'DiffRetainers'))));
